import { useMemo, useState } from "react";
import { useQuery } from "react-query";
import classNames from "classnames";

import { CCard, CCardBody } from "@coreui/react";

import { hangHoaApi } from "src/1/apis/hang_hoa.api";
import { CTable } from "src/1/common/components/others";
import { history } from "src/App";
import { CActionGroup } from "src/common/components/others";

const DanhSachYeuCauDieuChinhGia = () => {
  //#region Data
  const [params, setParams] = useState({
    page: 1,
    size: 10,
  });

  const { data, isFetching } = useQuery({
    queryKey: ["danh-sach-yeu-cau-dieu-chinh-gia", params],
    queryFn: () => hangHoaApi.getChangePriceList(params),
    select: (response) => response?.data,
  });

  const listData = useMemo(() => data?.data ?? [], [data]);
  //#endregion

  //#region Event
  const onLimitChange = (newLimit) =>
    setParams((prev) => ({
      ...prev,
      page: 1,
      size: newLimit,
    }));

  const onPageChange = (newPage) =>
    setParams((prev) => ({
      ...prev,
      page: newPage,
    }));

  const onClick = (key) => {
    switch (key) {
      case "add":
        history.push("/menus/change-price/form");
        break;

      default:
        break;
    }
  };
  //#endregion

  //#region Render
  const headers = [
    {
      key: "code",
      label: "Mã phiếu",
      width: 300,
      cellRender: (value, record) => (
        <span
          className="cursor-pointer text-blue-700 font-medium text-left"
          onClick={() =>
            history.push(`/menus/change-price/form/${record.id}/approve`)
          }
        >
          {value}
        </span>
      ),
    },
    { key: "adjustment_note", label: "Ghi chú", align: "left" },
    {
      key: "status",
      label: "Trạng thái",
      cellRender: (value, record) => (
        <span
          className={classNames(
            record?.approval_status === "done" && "text-green-500",
            record?.approval_status === "reject" && "text-red-500",
            "font-medium",
          )}
        >
          {value}
        </span>
      ),
    },
  ];
  return (
    <>
      <CCard>
        <CCardBody>
          <CActionGroup onClick={onClick} hidePrintBtn />
        </CCardBody>
      </CCard>

      <CCard>
        <CCardBody className="px-0">
          <CTable
            loading={isFetching}
            headers={headers}
            data={listData}
            fontSizeBody={16}
            divider
            page={params?.page}
            pages={data?.metadata?.last_page}
            limit={params?.size}
            total={data?.metadata?.total}
            onPageChange={onPageChange}
            onLimitChange={onLimitChange}
          />
        </CCardBody>
      </CCard>
    </>
  );
  //#endregion
};

export default DanhSachYeuCauDieuChinhGia;
